import { ActionIcon, Flex, Text, Tooltip } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { HiOutlineArrowDown, HiOutlineArrowUp } from 'react-icons/hi';

interface SequenceProps {
  data: any;
  rawData: any;
  index: number;
  itemNumber: number;
  headerProps: string;
  handleChangeSequence: (data: any, type: 'down' | 'up') => void;
}
const Sequence: React.FC<SequenceProps> = ({
  data,
  handleChangeSequence,
  index,
  itemNumber,
  headerProps,
  rawData
}) => {
  const [lastSequence, setLastSequence] = useState(0);
  const [startSequence, setStartSequence] = useState(0);

  useEffect(() => {
    if (rawData && rawData.length > 0) {
      const lastSequence = rawData.reduce((acc, item) => {
        if (item[headerProps] > acc) {
          acc = item[headerProps];
        }
        return acc;
      }, 0);

      const firstSequence = rawData.reduce((acc, item) => {
        if (item[headerProps] < acc || acc === 0) {
          acc = item[headerProps];
        }
        return acc;
      }, 0);
      setLastSequence(lastSequence);
      setStartSequence(firstSequence);
    }
  }, [rawData]);

  if (rawData && rawData.length === 1) return <Text>{rawData.length}</Text>;

  return (
    <Flex justify={'center'} gap={4} align={'center'} flex={1}>
      {data[index][headerProps] === startSequence && (
        <Tooltip label="Go Down Position">
          <ActionIcon
            variant="transparent"
            size="sm"
            onClick={() => handleChangeSequence(data[index], 'down')}
          >
            <Flex direction={'column'}>
              <HiOutlineArrowDown size={16} />
              <Text className="text-xs-bold">({data[index][headerProps]})</Text>
            </Flex>
          </ActionIcon>
        </Tooltip>
      )}

      {data[index][headerProps] !== startSequence &&
        data[index][headerProps] !== lastSequence && (
          <Flex direction={'column'} align={'center'} justify={'center'}>
            <Flex>
              <Tooltip label="Go Down Position">
                <ActionIcon
                  variant="transparent"
                  size="sm"
                  onClick={() => handleChangeSequence(data[index], 'down')}
                >
                  <Flex direction={'column'}>
                    <HiOutlineArrowDown size={16} />
                  </Flex>
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Go Up Position">
                <ActionIcon
                  variant="transparent"
                  size="sm"
                  onClick={() => handleChangeSequence(data[index], 'up')}
                >
                  <Flex direction={'column'}>
                    <HiOutlineArrowUp size={16} />
                  </Flex>
                </ActionIcon>
              </Tooltip>
            </Flex>
            <Text className="text-xs-bold">({data[index][headerProps]})</Text>
          </Flex>
        )}

      {data[index][headerProps] === lastSequence && (
        <Tooltip label="Go Up Position">
          <ActionIcon
            variant="transparent"
            size="sm"
            onClick={() => handleChangeSequence(data[index], 'up')}
          >
            <Flex direction={'column'}>
              <HiOutlineArrowUp size={16} />
              <Text className="text-xs-bold">({data[index][headerProps]})</Text>
            </Flex>
          </ActionIcon>
        </Tooltip>
      )}
    </Flex>
  );
};

export default Sequence;
